import { isObject } from '../is-object/is-object';
import { sortObjectKeys } from './sort-object-keys';
import { ParametersList } from './types';

export const isEqualParameters = ({
    previousParameters,
    currentParameters,
}: {
    previousParameters: ParametersList;
    currentParameters: ParametersList;
}) => {
    let previousValidParameters = previousParameters;
    let currentValidParameters = currentParameters;

    if (isObject(previousValidParameters)) {
        previousValidParameters = sortObjectKeys(previousValidParameters);
    }

    if (isObject(currentValidParameters)) {
        currentValidParameters = sortObjectKeys(currentValidParameters);
    }
    return JSON.stringify(previousValidParameters) === JSON.stringify(currentValidParameters);
};
